import axios from "axios";
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import qs from "qs";

let config = {
    // 每次请求的协议、IP地址。  设置该配置后，每次请求路径都可以使用相对路径，例如"/admin/login"
    baseURL: "",
    // 请求超时时间
    timeout: 300000,
    // 每次请求携带cookie
    withCredentials: true,
    // `responseType` 表示服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
    responseType: 'json'
};

const instance = axios.create(config);

// http request 拦截器
instance.interceptors.request.use(
    config => {
        const token = VueCookies.get('access_token');
        if (token) { //判断token是否存在
            config.headers['Authorization'] = 'Bearer '+token;  //将token设置成请求头
        }
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

// 自定义接口函数
instance.api = {
  // 学院-订阅课程
  memberCourses: function (params, callback) {
    instance.get(Vue.prototype.$env.VUE_APP_URL + "api/v2/member/courses?" + qs.stringify(params)).then((res) => {
      callback(res.data);
    }).catch((error) => {
      callback({"code": 0});
    });
  },
  // 学院-已购视频
  memberVideos: function (params, callback) {
    instance.get(Vue.prototype.$env.VUE_APP_URL + "api/v2/member/videos?" + qs.stringify(params)).then((res) => {
      callback(res.data);
    }).catch((error) => {
      callback({"code": 0});
    });
  },
  // 学院-历史学习
  memberCoursesHistory: function (params, callback) {
    instance.get(Vue.prototype.$env.VUE_APP_URL + "api/v2/member/courses/history?" + qs.stringify(params)).then((res) => {
      callback(res.data);
    }).catch((error) => {
      callback({"code": 0});
    });
  },
  // 学院-我的收藏
  memberCoursesLike: function (params, callback) {
    instance.get(Vue.prototype.$env.VUE_APP_URL + "api/v2/member/courses/like?" + qs.stringify(params)).then((res) => {
      callback(res.data);
    }).catch((error) => {
      callback({"code": 0});
    });
  },
  // 学院-我的预设
  memberAcrs: function (params, callback) {
    instance.get(Vue.prototype.$env.VUE_APP_URL + "api/v2/member/acrs?" + qs.stringify(params)).then((res) => {
      callback(res.data);
    }).catch((error) => {
      callback({"code": 0});
    });
  },
}

export default instance



// WEBPACK FOOTER //
// ./src/axios/index.js